"use strict";

module.exports = function () {
  return this.opts.filterable && this.opts.filterable.length ? this.opts.filterable : this.Columns;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/filterable-columns.js
// module id = 1562
// module chunks = 64